import React from "react";
import ReactMarkdown, { Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { useSmoothText } from "../hooks/useSmoothText";

export default function StreamingMarkdown({
  text,
  streaming,
  components,
  className = "",
}: {
  text: string;
  streaming: boolean;
  components?: Components;
  className?: string;
}) {
  const shown = useSmoothText(text, streaming);
  const revealing = streaming || shown.length < text.length;
  return (
    <div className={`${className} ${revealing ? "is-streaming" : ""}`} aria-busy={revealing || undefined}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {shown}
      </ReactMarkdown>
    </div>
  );
}
